import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import TreeModel from '../../../common/models/TreeModel';
import MetaTreeModel from './MetaTreeModel';
import Node from '../../../common/models/Node';
import Notice from "Components/Notice";
import _ from 'lodash';
/**
 * 异步加载指定节点的meta子节点数据
 * @param {String} metaid metaid
 */
export function asyncQueryMetaPro(metaid) {
    let { json } = this.props;
    return new Promise((resolve, reject) => {
        Ajax({
            url: `/nccloud/platform/templet/querymetapro.do`,
            info: {
                // 国际化处理： 单据模板设置
                name: langCheck('ZoneSetting-000017', 'pages', json),
                // 国际化处理： 元数据树结构查询
                action: langCheck('ZoneSetting-000020', 'pages', json),
            },
            data: {
                metaid: metaid
            },
            success: res => {
                if (res) {
                    let { data, success } = res.data;
                    if (success && data && data.rows && data.rows.length > 0) {
                        resolve(data);
                    } else {
                        Notice({ status: "warning", msg: langCheck('ZoneSetting-000021', 'pages', json) });/* 国际化处理： 元数据树为空*/
                    }
                }
            }
        });
    });
}
/**
 * 查询元数据
 * @param {String} metaid metaid
 * @param {String} text 搜索关键字
 */
export function queryMetaTreeData(metaid, text) {
    let { json } = this.props;
    return new Promise((resolve, reject) => {
        Ajax({
            url: '/nccloud/platform/templet/searchmeta.do',
            data: { metaid, text },
            info: {
                // 国际化处理： 单据模板设置
                name: langCheck('ZoneSetting-000017', 'pages', json),
                // 国际化处理： 元数据树结构查询
                action: langCheck('ZoneSetting-000020', 'pages', json),
            },
            success: ({data: { data }}) => {
                resolve(data);
            }
        })
    })
}

function initMetaTreeNodeInfo(node, nodesMap, targetAreaType) {
    let ret;
    // let { refcode, refname, pid, refpk, isleaf, pUniqID, datatype } = node;
    let { children, ...rest } = node;
    let { refcode, refname, pid, refpk, isleaf, pUniqID, datatype } = rest;
    let pNode = nodesMap.get(pUniqID);
    if (!pid) {
        // 根节点，对于根节点特殊处理，它的myUniqID是‘’
        ret = {
            ...rest,
            children,
            title: '',
            key: refpk,
            pUniqID: null,
            myUniqID: '0',
            level: 0,
            isLeaf: isleaf
        };
    } else {
        ret = {
            ...rest,
            children,
            title: `${refcode} ${refname}`,
            key: `${pNode.myUniqID === '0' ? '' : (pNode.myUniqID + '.')}${refcode}`,
            pUniqID: pNode.myUniqID,
            myUniqID: `${pNode.myUniqID === '0' ? '' : (pNode.myUniqID + '.')}${refcode}`,
            level: (pNode.level + 1),
            isLeaf: isleaf
        }
        //非查询区域的子表里的code不是全路径
        if (targetAreaType !== '0' && pNode.notSearchAreaCode) {
            ret.notSearchAreaCode = `${pNode.notSearchAreaCode}.${refcode}`;
        }
        //非查询区域的子表的code，若父级是205则直接为自身refcode
        if (targetAreaType !== '0' && pNode.datatype === '205') {
            ret.notSearchAreaCode = `${refcode}`;
        }
    }
    return ret;
}
/**
 * 创建元数据树实例
 * @param {Object} root 具有树层级结构的JSON
 */
export function createMetaTreeIns(root, targetAreaType) {
    // 为了兼容旧版本元数据树的处理需要先遍历树的节点数据，
    // 对其统一增加树组件需要的各个字段数据。
    // 包括title，key，myUniqID
    // console.time(`InitMetaTreeData`);
    let nodes = [];
    let map = new Map();
    let stack = [];
    let curNode = root;
    let nodeInfo = null;
    let tree = null;
    stack.push(curNode);

    while(stack.length > 0) {
        let { pid, refcode, refpk, childs } = curNode;
        let children = curNode.children ? curNode.children : childs;
        curNode.children = children;
        nodeInfo = initMetaTreeNodeInfo.call(this, curNode, map, targetAreaType);
        map.set(nodeInfo.myUniqID, nodeInfo);
        if (children && children.length > 0) {
            // 当前节点有子节点，需要继续遍历所有子节点。
            // 把当前节点的子节点入栈
            for (let i = children.length - 1; i >= 0; i--) {
                children[i].pUniqID = nodeInfo.myUniqID;
                stack.push(children[i]);
            }
        }
        // nodes.push(nodeInfo);
        curNode = stack.pop();
    }
    map.forEach(el => {
        nodes.push(el);
    });
    // console.log(nodes, nodes.length);
    map.clear();
    // console.timeEnd(`InitMetaTreeData`);
    // console.time(`CreateMetaTreeIns`);
    // tree = MetaTreeModel.createTree(nodes, el => el.myUniqID, el => el.pUniqID);
    tree = MetaTreeModel.createBigTree(nodes, el => el.myUniqID, el => el.pUniqID);
    // console.timeEnd(`CreateMetaTreeIns`);
    // console.log(tree);
    return tree;
}

/**
 * 把子节点数据插入到元数据树中
 * @param {Array} items 子节点数组
 * @param {String} pUniqID 父节点的id
 * @param {MetaTreeModel} tree 树实例
 */
export function appendMetaTreeNodes(items, pUniqID, tree) {
    let { targetAreaType } = this.props;
    let pNode = tree.getNode((node) => node.data.myUniqID === pUniqID);
    let { children, refpk, myUniqID, notSearchAreaCode, datatype, dataRef } = pNode.data;
    let subTreeNodes = [];
    let subTreeDatas = items.map((el) => {
        let tmpNode = {
            ...el,
            title: `${el.refcode} ${el.refname}`,
            key: `${myUniqID}.${el.refcode}`,
            pUniqID,
            myUniqID: `${myUniqID}.${el.refcode}`,
            isLeaf: el.isleaf
        };
        // 非查询区域的子表里的code不是全路径
        if (targetAreaType !== '0' && notSearchAreaCode) {
            tmpNode.notSearchAreaCode = `${notSearchAreaCode}.${el.refcode}`;
        }
        // 非查询区域的子表的code，若父级是205则直接为自身refcode
        if (targetAreaType !== '0' && datatype === '205') {
            tmpNode.notSearchAreaCode = `${el.refcode}`;
        }
        let node = new Node(tmpNode);
        node.parent = pNode;
        subTreeNodes.push(node);
        return tmpNode;
    });
    pNode.data.children = subTreeDatas;
    pNode.children = subTreeNodes;
    return tree;
}
/**
 * 关键字搜索元数据
 * @param {String} text 关键字
 * @param {MetaTreeModel} tree 树实例
 * @param {Array}   searchExpandedKeys 展开的节点
 */
export function queryMetaPropByKeyWords(text, tree, searchExpandedKeys) {
    let root = tree.getRoot();
    let serializeTree = MetaTreeModel.serialize(tree);
    let allNodes = serializeTree.nodes.reverse();
    let map = new Map();
    allNodes.forEach(el => map.set(el.data.myUniqID, el));
    // console.time('FilterNodes');
    let matchedNodes = _.filter(allNodes, el => el.data.title.indexOf(text) > -1);
    let nextTreeNodes = [];
    let curNode;
    // 遍历所有搜索结果节点，并找出每个结果节点的路径节点
    while(matchedNodes.length > 0) {
        curNode = matchedNodes.pop();
        // console.log(`matchedNodes.length:${matchedNodes.length}`);
        let pUniqID = curNode.data.pUniqID;
        if (pUniqID) {
            // 当前节点的父节点不为根节点
            let pnode = map.get(pUniqID);
            if (pnode) {
                if (pnode.data.myUniqID !== '0' && !(_.find(matchedNodes, el => el.data.myUniqID === pnode.data.myUniqID))) {
                    matchedNodes.unshift(pnode);
                }
                if (!pnode.data.isLeaf && searchExpandedKeys.indexOf(pUniqID) < 0) {
                    searchExpandedKeys.push(pUniqID);
                }
                if (!curNode.data.isLeaf && curNode.children.length > 0 && !(_.find(matchedNodes, el => el.data.pUniqID === curNode.data.myUniqID))) {
                    searchExpandedKeys.push(curNode.data.myUniqID);
                }
            }
        }
        nextTreeNodes.push(curNode.data);
    }
    // 先把匹配的节点数组去重
    // nextTreeNodes = [...new Set(nextTreeNodes)];
    nextTreeNodes = _.filter(nextTreeNodes, el => el.myUniqID !== '0');
    if (nextTreeNodes.length === 0) {
        let { children, ...rest } = root.data;
        let emptyRootData = {
            ...rest,
            children: []
        };
        nextTreeNodes.unshift(emptyRootData);
    } else {
        nextTreeNodes.unshift(root.data);
    }

    let nextTree = MetaTreeModel.createBigTree(nextTreeNodes, el => el.myUniqID, el => el.pUniqID);
    // console.timeEnd('FilterNodes');
    return nextTree;
}
